import React from 'react'
import loadingImg from '../img/loading.svg'

export const Loading = (props) => {
  return(<div style={{"text-align": "center"}}>
          <img class="learn-section-loading" alt="Loading..." src={loadingImg}/>
        </div>);
    };



// WEBPACK FOOTER //
// ./src/components/generic.js